import React from 'react'
import { makeStyles, withStyles} from 'external/material'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import AddIcon from '@mui/icons-material/Add'

const AddButton = withStyles({
  root: {
    boxShadow: 'none',
    border: 'solid 1px #d6dbdf',
    backgroundColor: '#fff',
    borderRadius: 2,
    color: '#68728b',
    '& svg': {
      marginTop: -3
    },
    '&:hover': {
      backgroundColor: '#c7dcef',
      boxShadow: 'none',
    },
  },
  label: {
    textTransform: 'none'
  }
})(Button)

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    marginTop: 20
  },
  button: {
    flexGrow: 1
  },
  addIcon: {
    fontSize: '14pt'
  }
}))

export default function AddAnswer ({context, question, index, onAddAnswer}) {

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <AddButton
        variant="contained"
        color="primary"
        onClick={onAddAnswer}
        className={classes.button}
      >
        <AddIcon className={classes.addIcon}/>{context.translate('add-answer')}
      </AddButton>
    </div>
  )
}
